import { makeStyles } from '@mui/styles';
const CELL_BORDER = '1px solid #e0e0e0';
const useStyles = makeStyles({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    maxWidth: 900
  },
  intro: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: CELL_BORDER,
    padding: '10px 0'
  },
  headerCell: {
    padding: '12px 12px 12px 0',
    borderRight: CELL_BORDER
  },
  cell: {
    padding: '8px 12px 8px 0',
    minWidth: 0,
    overflowWrap: 'anywhere'
  },
  actions: {
    display: 'flex',
    gap: 4,
    marginLeft: 'auto'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  formRow: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap'
  },
  field: {
    flex: '1 1 220px'
  },
  defaultHint: {
    marginTop: 4
  },
  empty: {
    padding: '24px 0'
  }
});
export default useStyles;